import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=6be43bf3&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be43bf3",
  null
  
)

export default component.exports